import { map, take, filter } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { createSelector } from '@ngrx/store';
import { WeekDay } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-date/models/week-day';
import * as moment from 'moment';
import { isSameDay } from 'app/calendar-view/utils/is-same-day';
import { getOneClickNextWorkingDay } from '../../selectors/one-click-next-working-day.selector';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { getHolidays } from '@ordersnproducts/modules/order-builder/reducers';

const getHolidaysAndNextWorkingDay = createSelector(
  getOneClickNextWorkingDay,
  getHolidays,
  (nextWorkingDay, holidays) => {
    return {
      nextWorkingDay,
      holidays,
    };
  },
);
export class OneClickNextWorkingDayProvider extends BaseAsyncValue<Date> {
  /**
   * This class provide a min day considering the function of nextWorkingDay, Holidays and Sundays
   *
   */
  getValue(): Observable<Date> {
    return this.store.select(getHolidaysAndNextWorkingDay).pipe(
      filter(dates => dates.holidays !== null),
      filter(dates => dates.nextWorkingDay !== null),
      take(1),
      map(({ nextWorkingDay, holidays }) => {
        while (
          holidays.filter(date => {
            return isSameDay(date.toISOString(), nextWorkingDay.toDateString());
          }).length > 0
        ) {
          if (nextWorkingDay.getDay() === WeekDay.SATURDAY) {
            nextWorkingDay = moment(nextWorkingDay)
              .add(2, 'day')
              .toDate();
          } else {
            nextWorkingDay = moment(nextWorkingDay)
              .add(1, 'day')
              .toDate();
          }
        }
        return nextWorkingDay;
      }),
    );
  }
}
